<template>
  <div class="w-6">
    <RateDetailTable
      :header="t('common.paramDetails', { param: t('carriers.carriers') })"
      :value="carrierDetails"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed, Ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Contact } from '@/model';

import RateDetailTable, {
  RateQuoteDetails,
} from '@/components/rateShop/expandedDetails/RateDetailTable.vue';

const props = defineProps({
  contact: {
    type: Contact,
    default: () => new Contact(),
  },
});
const { contact } = toRefs(props);

const { t } = useI18n();

const carrierDetails: Ref<RateQuoteDetails[]> = computed(() => [
  {
    k: t('common.name'),
    v: contact.value?.name ?? '-',
  },
  {
    k: t('common.phone'),
    v: contact.value?.phone ?? '-',
  },
  {
    k: t('common.email'),
    v: contact.value?.email ?? '-',
  },
]);
</script>
